// @ts-nocheck


import React, { useCallback, useMemo } from 'react';


import { SignalLevel, Wrapper } from './styles';





export const Signal = ({ level }) => {
  const isActive = useCallback(
    (index) => {
      return index <= level - 1;
    },
    [level]
  );

  const signalLevels = useMemo(() => {
    return ['4px', '5px', '7px', '8px', '10px', '12px'].map((height, index) =>
    <SignalLevel height={height} active={isActive(index)} />
    );
  }, [isActive]);

  return <Wrapper>{signalLevels}</Wrapper>;
};
